import React from 'react';

const StashDisclaimer = () => (
  <div className="disclaimer">
    <p>
      Paid non-client promotion. The paid partner received cash compensation of
      up to $150.00 (per cost per action) for providing this endorsement.
      Compensation creates an incentive for the individual to recommend Stash.
      Endorsements are not representative of the experience of all clients and
      are not guarantees of future performance or success. For a representative
      sample of client testimonials, refer to Apple App Store or Google Play
      reviews. To begin investing on Stash, you must be approved from an account
      verification perspective and open a brokerage account (&quot;Personal
      Portfolio&quot;). Promotion offer is subject to Terms and Conditions.
      Nothing in this material should be construed as an offer, recommendation,
      or solicitation to buy or sell any security. All investments are subject
      to risk and may lose value. View important&nbsp;
      <a
        target="_blank"
        rel="noreferrer"
        href="https://www.stash.com/start-investing?code=Nerdwallet25"
      >
        disclosures
      </a>
      . NerdWallet and Stash are not under common ownership and are not related
      entities.
    </p>
  </div>
);

StashDisclaimer.propTypes = {};
StashDisclaimer.displayName = 'StashDisclaimer';

export default StashDisclaimer;
